import React from 'react';

import Item from './Menu.item';
import { FMSItem } from './types';
import useTranslation from '../../translation/useTranslation';

function Default() {
  const { t } = useTranslation();
  const items = t<FMSItem[]>('menu.items');

  return items.map((item, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <Item key={`${item.type}-${index}`} {...item} />
  ));
}

export default Default;
